var isEmpty = function(value) {
  return  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0)
 }

 exports.isEmpty = isEmpty;


// WEBPACK FOOTER //
// ./client/src/common/utils.js